import { Position } from "@/services/backend/vbs/treatments/types/position";
import { useState } from "react";
import {
  UpdateSpecialDiscountActiveRequest,
  UpdateSpecialDiscountAmountRequest,
  useVbsTreatmentUpdateSpecialDiscountActiveMutation,
  useVbsTreatmentUpdateSpecialDiscountAmountMutation,
} from "@/services/backend/vbs/treatments/api/treatment-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { Input } from "@/shared/components/ui/input";
import { cn } from "@/shared/lib/utils";
import { tableInputClass } from "@/shared/components/tables/table-input-class";
import { Checkbox } from "@/shared/components/ui/checkbox";

export function SpecialDiscountCell({
  treatmentId,
  position,
  disabled = false,
}: {
  treatmentId: string;
  position: Position;
  disabled?: boolean;
}) {
  return (
    <div className="flex items-center justify-end gap-2">
      <ActiveCheckbox
        treatmentId={treatmentId}
        position={position}
        disabled={disabled}
      />
      <AmountInput
        treatmentId={treatmentId}
        position={position}
        disabled={disabled}
      />
    </div>
  );
}

function ActiveCheckbox({
  treatmentId,
  position,
  disabled = false,
}: {
  treatmentId: string;
  position: Position;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateSpecialDiscountActiveRequest>({
    id: treatmentId,
    positionId: position.id,
    active: position.specialDiscountActive,
  });
  const mutation = useVbsTreatmentUpdateSpecialDiscountActiveMutation();
  const { isLoading } = useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: treatmentId,
      positionId: position.id,
      active: position.specialDiscountActive,
    },
    { delay: 0 },
  );

  return (
    <Checkbox
      checked={request.active}
      onCheckedChange={(checked) =>
        setRequest({
          ...request,
          active: checked === "indeterminate" ? false : checked,
        })
      }
      disabled={isLoading || disabled}
    />
  );
}

function AmountInput({
  treatmentId,
  position,
  disabled = false,
}: {
  treatmentId: string;
  position: Position;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateSpecialDiscountAmountRequest>({
    id: treatmentId,
    positionId: position.id,
    amount: position.specialDiscountAmount,
  });
  const mutation = useVbsTreatmentUpdateSpecialDiscountAmountMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: treatmentId,
    positionId: position.id,
    amount: position.specialDiscountAmount,
  });

  return (
    <div>
      <Input
        type="number"
        className={cn(tableInputClass, "inline-flex w-12")}
        value={position.specialDiscountActive ? request.amount : 0}
        onChange={(e) =>
          setRequest({
            ...request,
            amount: Number(e.target.value),
          })
        }
        disabled={disabled}
      />
      <span className="ml-1">€</span>
    </div>
  );
}
